import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-click-toggle',
  templateUrl: './click-toggle.component.html',
  styleUrls: [],
  providers: [
    {
      provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
      useValue: { disableDragValue: true, disableToggleValue: true },
    },
  ],
})
export class ClickToggleComponent {
  @Input() value?: boolean;
  @Input() disabled?: boolean;
  @Output() clickEvent = new EventEmitter();

  onClick() {
    if (!this.disabled) {
      this.clickEvent.emit();
    }
  }
}
